require('./authorizationActivation.scss');

const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
// @ helpers
import { i18n } from 'core/i18n';
import { todayDate } from 'utilities/dateHelper';
const { formatText, FormattedText, getFinalTitle, getLanguage } = i18n;
const { getLastNChars } = require('utilities/stringHelper');
// @ actions
import { authorizationActivation, authorizationActivationReset } from 'actions/accountDebits/authorizationActivation';
import { validateAndExecuteSagas } from 'actions/signaturePattern';
// @components
import { LabelDate } from 'commonsComponents/labelDate';
import WizardError from 'components/commons/wizardError/wizardError';
import WizardSuccess from 'components/commons/wizardSuccess/wizardSuccess';
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const { OKButton } = require('components/commons/OKButton/OKButton');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
// @ constants
import { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } from 'constants/commonsComponents';
const { DEBIT_REACTIVATION_NEXT_PAYMENTS } = require('constants/operationTypes');

class AuthorizationActivation extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    componentWillUnmount() {
        this.props.authorizationActivationReset();
    }

    breadcrumb = (accountId) => {
        return [
            {
                text: formatText('breadcrumb-accounts'),
                url: '/myprofile/accounts'
            },
            {
                text: formatText('breadcrumb-debits'),
                url: `/myprofile/accounts/${accountId}/debits`
            },
            {
                text: formatText('breadcrumb-authorizationActivation'),
                url: ''
            }
        ];
    }

    createOriginAccountParam = (account) => {
        return account && `00730100${account.get('newProduct')}${account.get('newContractNumber')}`
    }

    renderDateCell = (date) => {
        return (
            <LabelDate
                date={date}
                language={getLanguage()}
                today={LABEL_DATE_TODAY}
                yesterday={LABEL_DATE_YESTERDAY}
            />
        )
    }

    renderActivationFailed = (exitLink) => {
        const goBackButton = {
            label: formatText('authorizationActivation-backToDebits'),
            url: exitLink
        }
        return (
            <WizardError
                errorMessage={formatText('authorizationActivation-errorTitle')}
                mainButton={goBackButton}
            >
                <p>
                    <FormattedText value="authorizationActivation-errorSubTitle" />
                </p>
            </WizardError>
        )
    }

    renderActivationSuccess = (exitLink) => {
        const goBackButton = {
            label: formatText('authorizationActivation-backToDebits'),
            url: exitLink
        }
        return (
            <WizardSuccess
                successMessage={formatText('authorizationActivation-successTitle')}
                mainButton={goBackButton}
            >
                <p>
                    <FormattedText value="authorizationActivation-successSubTitle" />
                </p>
            </WizardSuccess>
        )
    }

    renderActivationProgress() {
        const {
            match: { params: { authorizationId } },
            immAccount,
            immAuthorization,
            immReceipt
        } = this.props;
        const alias = immAccount.get('alias');
        const ibanFormatted = getLastNChars(immAccount.get('iban'));
        const date = immAuthorization.get('fechaFirma');
        const accountInCharge = alias + ibanFormatted;
        const issuingCompanyName = immAuthorization.get('nombreActuante');
        const beneficiaryName = immReceipt.get('titular');
        const operationParams = {
            originAccount: this.createOriginAccountParam(immAccount),
            optional1: todayDate()
        };

        const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
        const cancelText = formatText('wizard-redirectConfirmationCancelButton');
        const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
        const confirmationMessage = formatText('wizard-redirectConfirmationMessage');

        return (
            <div>
                <PreLeaveModalComponent
                    confirmationMessage={confirmationMessage}
                    confirmationTitle={confirmationTitle}
                    acceptText={acceptText}
                    cancelText={cancelText}
                    isReady={this.isReady}
                />
                <div className="authorization-activation__title">
                    <FormattedText value="authorizationActivation-title" />
                </div>
                <div className="authorization-activation__text">
                    <FormattedText value="authorizationActivation-text" />
                </div>
                <div className="authorization-activation__header-container">
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title={formatText('accountDebit-issuingCompanyName')}
                            bodyText={issuingCompanyName}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebit-beneficiaryName')}
                            bodyText={beneficiaryName}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebit-ibanFormatted')}
                            bodyText={accountInCharge}
                        />
                    </OKInformativeList>
                    <OKInformativeList columns={3}>
                        <OKInformativeListItem
                            title={formatText('accountDebit-issuingCompanyId')}
                            bodyText={authorizationId}
                        />
                        <OKInformativeListItem
                            title={formatText('accountDebits-activationDate')}
                            bodyText={this.renderDateCell(date)}
                        />
                        <div className="col-xs-4" />
                    </OKInformativeList>
                </div>
                <div className="authorization-activation__signature-container">
                    <SignaturePattern
                        operationType={DEBIT_REACTIVATION_NEXT_PAYMENTS}
                        operationParams={operationParams}
                    />
                </div>
                <div className="row authorization-activation__actions-container">
                    <div className="col-xs-6">
                        <OKButton
                            modifier="link-ghost"
                            onClick={this.handleCancel}
                        >
                            <FormattedText value="accountDebitAnnulation-cancel" />
                        </OKButton>
                    </div>
                    <div className="col-xs-6 text-right">
                        <OKButton
                            onClick={this.handleAuthorizationActivation}
                        >
                            <FormattedText value="common-confirm" />
                        </OKButton>
                    </div>
                </div>

            </div>
        );
    }

    handleCancel = () => {
        const { match: { params: { accountId } }, history } = this.props;
        history.push(`/myprofile/accounts/${accountId}/debits`);
    }

    handleAuthorizationActivation = () => {
        const {
            immAccount,
            immAuthorization,
            authorizationActivation,
            validateAndExecuteSagas
        } = this.props;
        const authCode = immAuthorization.getIn(['claveAviso', 'codinternogau']);
        const authType = immAuthorization.getIn(['claveAviso', 'tipoautorizaciongau', 'codalfanum']);
        const notice = immAuthorization.get('tipoAviso');
        const noticeActivation = immAuthorization.get('noticeActivation');
        const newProduct = immAccount.get('newProduct');
        const newContractNumber = immAccount.get('newContractNumber');
        validateAndExecuteSagas((dispatch, getState, dataToken) => {
            authorizationActivation(newProduct, newContractNumber, authCode, authType, notice, noticeActivation, dataToken);
        })
    }

    isReady = () => {
        return false;
    }

    renderActivation = (accountId, submitSuccessful, errorMessage) => {
        const exitLink = `/myprofile/accounts/${accountId}/debits`;
        if (!submitSuccessful) {
            return this.renderActivationProgress();
        } else {
            if (errorMessage) {
                return this.renderActivationFailed(exitLink);
            } else {
                return this.renderActivationSuccess(exitLink);
            }
        }
    }

    render() {
        const { immAccount, immAuthorizationActivation, match: { params: { accountId } } } = this.props;
        const submitSuccessful = immAuthorizationActivation.get('submitSuccessful');
        const errorMessage = immAuthorizationActivation.get('errorReceived');

        if (immAccount && immAccount.size) {
            return (
                <section className="authorization-activation">
                    <OKCover size="medium" section="accounts">
                        <OKHeaderSubPage
                            breadcrumbConfig={this.breadcrumb(accountId)}
                            finalTitle={getFinalTitle('landingHeader-authorizationActivation')}
                        />
                    </OKCover>
                    <div className="authorization-activation__body">
                        <div className="authorization-activation__body-column">
                            {this.renderActivation(accountId, submitSuccessful, errorMessage)}
                        </div>
                    </div>
                </section>
            )
        } else {
            return null;
        }
    }
}
AuthorizationActivation.propTypes = {
    authorizationActivation: PropTypes.func.isRequired,
    authorizationActivationReset: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccount: PropTypes.object.isRequired,
    immAuthorization: PropTypes.object.isRequired,
    immReceipt: PropTypes.object.isRequired,
    immAuthorizationActivation: PropTypes.object.isRequired,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};
module.exports.constructor = AuthorizationActivation;
module.exports.AuthorizationActivation = connect(
    (state, ownProps) => {
        const authorization = state.authorizations.getIn([ownProps.match.params.accountId, 'byId', ownProps.match.params.authorizationId]);
        return {
            immAccount: state.accounts.getIn(['byId', ownProps.match.params.accountId]),
            immAuthorization: authorization,
            immReceipt: state.receipts.getIn([ownProps.match.params.accountId, 'byId', authorization.getIn(['receiptsIds', 0])]),
            immAuthorizationActivation: state.authorizationActivation
        }
    },
    {
        authorizationActivation,
        authorizationActivationReset,
        validateAndExecuteSagas
    }
)(withRouter(AuthorizationActivation));
